<template>
    <div>
        <v-select :multiple="false" :options="optionsGestores" :placeholder="'Selecciona '+placeholderm"
                  v-model="selectedGestores" @input="setCambio"></v-select>
    </div>
</template>

<script>
export default {
    name: "gestores",
    props:{
        placeholderm:String,
    },
    data(){
        return{
            selectedGestores:[],
            optionsGestores:[]
        }
    },
    mounted() {
        this.getGestores();
    },
    methods:{
        getGestores(){
            let $this = this;
            axios.post('/api/AdminCatalogos/supervisores')
                .then(r => {
                        $this.optionsGestores = r.data;
                        //console.log(r);
                    },
                    error => {$this.$toastMessage('error','Error: ' + error +' Por favor envia este error al área de soporte!',9000,'center');}
                );
        },
        setCambio(){
            this.$emit('cambioGestor');
        }
    }
}
</script>

<style scoped>

</style>
